<template lang='pug'>
  DataProvider(:endpoint='endpoint', :filter='filter' ref='dataProvider')
    div(slot-scope='{ data: response, error, loading }')
      DataTable(
        v-if='response && response.data'
        :data='response && response.data'
        ref='dataTable'
        :title="title ? title: 'Lista de Conversas'",
        :customTotal='(response && response.total) || 0'
        @pagination='handlePagination'
        @click-row='openDialog',
        :currentSort.sync='filter.orderBy',
        :currentSortOrder.sync='filter.order',
        :selectable='false'
        :loading='loading'
        customHeader
        :endpoint='endpoint'
        :filter='filter'
        :labels='labels'
        :formatLabelFunction='formatLabels'
        :createHeader='createHeaderPDF'
        :searchLabelsProps='searchLabels'
        @search-options='searchOptions'
        @search-query='handleSearch'
        fileName='busca_por_mensagens'
      )
        template(slot='footer' slot-scope='{ pagination }')
          v-row(style='justify-content: flex-end;')
            v-col(cols='auto')
              md-field
                label(for='pages') {{ $t('assistantsList.perPage') }}
                md-select(v-model='pagination.perPage' name='pages' )
                  md-option(
                    v-for='item in pagination.perPageOptions',
                    :key='item',
                    :label='item',
                    :value='item')
                    | {{ item }}
        template(slot='cells' slot-scope='{ item }')
          md-table-cell(:md-label='labels[0]' md-sort-by='process_time') {{ formatLabels(item, 0) }}
          md-table-cell(:md-label='labels[1]') {{ formatLabels(item, 1) }}
          md-table-cell(:md-label='labels[2]') {{ formatLabels(item, 2) }}
          md-table-cell(:md-label='labels[3]' style='display: table-cell;' v-html='formatLabels(item, 3)')
      v-dialog(v-model='dialog' max-width='700px' scrollable persistent)
        ChatConversation(
          :chatLoader='chatLoader'
          :chatData='chatData'
          :chatInfo='chatInfo'
          :channelConfig='channelConfig'
          :key='chatInfo._id'
          @close='closeDialog'
        )
</template>
<script>
import Pagination from '@/components/Pagination.vue'
import chatsList from '@/pages/data/chatsList'
import DateIntervalComponent from '@/components/DateInterval.vue'
import DataTable from '@/components/SearchMessages/Table.vue'
import DataProvider from '@/components/DataProvider'
import ChatConversation from '@/components/ChatConversation'
import { mapFields } from 'vuex-map-fields'
import { mapGetters } from 'vuex'
import * as moment from 'moment'
import mock from '@/components/SearchMessages/mock'
import { selectedLocale } from '@/plugins/i18n'

export default {
  props: {
    title: {
      type: String
    },
    processTime: {
      type: String,
      default: () => moment().format('YYYY-MM-DD[T]HH:mm:ssZ')
    }
  },
  components: {
    Pagination,
    DateIntervalComponent,
    DataTable,
    DataProvider,
    ChatConversation
  },
  watch: {
    dateInterval: {
      deep: true,
      handler (nV) {
        this.updatedDate()
      }
    }
  },
  data () {
    return {
      assistantName: '',
      searchLabels: [
        this.$t('search.operator'),
        this.$t('search.assistant'),
        this.$t('search.assistantUser'),
        this.$t('search.operatorUser'),
        this.$t('search.userNotFound')
      ],
      search: null,
      labels: [
        this.$t('search.start'),
        this.$t('search.sentBy'),
        this.$t('search.topic'),
        this.$t('search.message')
      ],
      response: {
        data: mock,
        total: 4
      },
      dialog: false,
      chatLoader: false,
      showFilter: true,
      // Chat List
      filter: {
        order: 'desc',
        orderBy: 'request_datetime',
        page: 0,
        perPage: null,
        by: null,
        search: null,
        process_time: this.processTime
      },
      tableData: chatsList,
      searchedData: [],
      chatData: {},
      chatInfo: {},
      channelConfig: null
    }
  },
  computed: {
    ...mapFields('chatHistoryFilter', ['sender_name']),
    ...mapFields('reports', ['dateInterval']),
    ...mapGetters('workspaces', ['active']),
    ...mapGetters('snapshots', ['appliedSnapshot']),
    ...mapFields('selectedAssistant', ['assistantId']),
    endpoint () {
      return `${process.env.VUE_APP_REPORTS_BACKEND}/messages`
    },
    hasActiveWorkspace () {
      return this.active ? (this.appliedSnapshot ? 1 : 0) : 0
    }
  },
  mounted () {
    if (typeof this.assistantId !== typeof null) {
      let generalConfig = null
      this.$axios.get(`/assistant-configs/${this.assistantId}`)
        .then(response => {
          generalConfig = response.data
          if (generalConfig.constructor === Array) {
            generalConfig = response.data[0]
          }
          if (generalConfig.webclientChannels) {
            const channelConfig = generalConfig.webclientChannels[0]
            this.assistantName = channelConfig.config.assistantName
          }
        })
    }
  },
  methods: {
    mappingOptions (value) {
      const result = []
      value.split(',').map(item => {
        switch (item) {
          case 'Usuário ➔ Assistente':
          case 'Usuario ➔ Asistente':
          case 'User ➔ Assistant':
            result.push(`${this.assistantName}`)
            break
          case 'Usuário ➔ Operador':
          case 'Usuario ➔ Operador':
          case 'User ➔ Operator':
            result.push('user_operator')
            break
          case 'Usuário ➔ Não Encontrou':
          case 'Usuario ➔ No Encontró':
          case 'User ➔ Did Not Find':
            result.push('usernotfound')
            break
          case 'Operador':
          case 'Operator':
            result.push('operator')
            break
          case 'Assistente':
          case 'Assistant':
          case 'Asistente':
            result.push('machine')
            break
          default:
            break
        }
      })
      return result.toString()
    },
    searchOptions (nV) {
      if (nV?.length > 0) {
        this.$set(this.filter, 'opt', this.mappingOptions(nV.toString()))
      } else {
        this.$delete(this.filter, 'opt')
      }
    },
    handleSearch (searchText) {
      if (searchText) {
        this.$set(this.filter, 'search', searchText)
      } else {
        this.$delete(this.filter, 'search')
      }
    },
    changeFilters () {
      // Keep process_time constant for the session
      this.$set(this.filter, 'process_time', this.processTime)
      this.filter.service_code = this.protocol
      this.filter.user_name = this.user_name
      this.filter.user_id = this.cpf
      this.filter.user_contact = this.phone
      this.filter.bot = this.bot
      this.filter.channel = this.channelFilter
      this.filter.evaluation = this.evaluationFilter
      this.filter.intent = this.intentFilter
      // this.filter.search = this.searchBarText
      this.$refs.dataProvider.load()
    },
    toggleShowFilter () {
      this.showFilter = !this.showFilter
    },
    endReason (item) {
      if (item._source.closed_by_operator) {
        return (this.$t('search.attendant'))
      } else if (item._source.closed_by_user) {
        return (this.$t('search.user'))
      } else if (item._source.expired_by_user_inactivity) {
        return (this.$t('search.userInactivity'))
      } else {
        return ('-')
      }
    },
    handlePagination (pagination, oldPagination) {
      const newFilter = {}
      const { currentPage, perPage } = pagination
      if (currentPage && this.filter.page !== currentPage - 1) {
        newFilter.page = currentPage - 1
      }
      if (perPage && this.filter.perPage !== perPage) {
        newFilter.perPage = perPage
      }
      Object.assign(this.filter, newFilter)
    },
    async openDialog (rowProps) {
      // eslint-disable-next-line camelcase
      const conversationId = rowProps.item._source?.conversation_id
      this.dialog = true
      this.chatLoader = true
      try {
        const result = await this.$axios.get(`${process.env.VUE_APP_REPORTS_BACKEND}/interactions`, {
          params: {
            page: 0,
            perPage: 1000,
            conversationId: conversationId,
            event: 'search-interactions'
          }
        })
        this.chatData = result.data
        this.chatInfo = result.data.parent ? result.data.parent : {} // rowProps.item
      } catch (error) {
      }
      this.chatLoader = false
    },
    closeDialog () {
      this.dialog = false
    },
    updatedDate () {
      this.filter.from = this.dateInterval.timestamp1
      this.filter.to = this.dateInterval.timestamp2
      this.$refs.dataProvider.load()
    },
    formatDate (item, type) {
      let date = item._source[type]
      return moment(date).locale(selectedLocale).format('L LT')
    },
    leadZeros (pad, number) {
      return String(number).padStart(pad, '0')
    },
    checkIfFormatDuration (item) {
      return item._source.total_duration ? this.fomartDuration(item._source.total_duration) : '-'
    },
    fomartDuration (duration) {
      let minutes, seconds
      if (duration >= 1) {
        minutes = Math.floor(duration)
      }
      const fractionOfSeconds = Math.ceil(duration) - duration
      seconds = Math.round(fractionOfSeconds * 60)
      return `${minutes ? minutes + 'min' : ''}${seconds ? seconds + 's' : ''}`
    },
    formatLabels (item, i) {
      switch (i) {
        case 0:
          return this.formatDate(item, 'process_time')
        case 1:
          // eslint-disable-next-line camelcase
          return item._source?.sender_name ? item._source.sender_name : '-'
        case 2:
          // eslint-disable-next-line camelcase
          return item._source?.topic ? item._source.topic : '-'
        case 3:
          // eslint-disable-next-line camelcase
          return item.highlight?.event_text.length > 0 ? item.highlight?.event_text[0] : item._source.isLogicallyDeleted ? 'Acesso ao anexo expirou' : item._source.event_text
        default:
          break
      }
    },
    // formatSender (type, name) {
    //   let rightName = name
    //   switch (type) {
    //     case 'user':
    //       rightName = 'Usuário'
    //       break
    //     case 'operator':
    //       rightName = 'Operador'
    //       break
    //     default:
    //       break
    //   }
    //   return rightName
    // },
    createHeaderPDF (doc, total) {
      doc.setFontSize(14)
      doc.setFont(undefined, undefined, '700')
      doc.text(15, 10, this.$t('search.searchByMessage'))

      doc.setFontSize(10)
      doc.setFont('times', undefined, '700')
      doc.text(15, 17, this.$t('search.timeCourse'))
      doc.setFont('times', undefined, '300')

      let formattedDate1 = moment(this.filter.from).format('DD/MM/YYYY H:mm:ss')
      let formattedDate2 = moment(this.filter.to).format('DD/MM/YYYY H:mm:ss')
      doc.text(29, 17, `${formattedDate1} até ${formattedDate2}`)

      doc.setFont('times', undefined, '700')
      doc.text(15, 22, this.$t('search.totalConversations'))
      doc.setFont(undefined, undefined, '300')
      doc.text(46, 22, `${total}`)

      const tableOffsetY = 30
      return tableOffsetY
    }
  },
  created () {
    this.dateInterval = {
      timestamp1: moment().subtract(1, 'week').startOf('day').format('YYYY-MM-DD[T]HH:mm:ss'),
      timestamp2: moment().endOf('day').format('YYYY-MM-DD[T]HH:mm:ss')
    }
    this.filter.from = this.dateInterval.timestamp1
    this.filter.to = this.dateInterval.timestamp2
  }
}
</script>
<style lang='css'>
#custom-filter-input > .v-text-field .v-input__control {
  margin: auto;
}
</style>
